var path = 'public/app/plugins/panel/graph/tab_thresholds_time_regions.html';
var html = "<graph-threshold-form panel-ctrl=ctrl></graph-threshold-form>\n<graph-time-region-form panel-ctrl=ctrl></graph-time-region-form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;